export default {
  // START:: GET APP THEME
  getAppTheme(state) {
    return state.sakn_w_safar_admin_dashboard_theme;
  },
  // END:: GET APP THEME GETTER
};
